import React from 'react';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CircularProgress from '@material-ui/core/CircularProgress';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

export default class InstallmentConfig extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            products: [],
            included: [],
            selectedProductId: '',
            config: null,
            saving: false,
            maxInstallments: 1, // Default
            rules: [],
            productValue: 0
        };
    }

    componentDidMount() {
        this.fetchProducts();
    }

    fetchProducts = (silent = false) => {
        if (!silent) this.setState({ loading: true });
        return this.props.fetchApi('get', '/products?include=product-installment-configs')
            .then(response => {
                this.setState({
                    products: response.data.products,
                    loading: false
                });
                return response.data.products;
            })
            .catch(error => {
                console.error('Error fetching products:', error);
                this.props.showSnackbar('Erro ao carregar produtos.');
                this.setState({ loading: false });
            });
    }

    handleProductChange = (event) => {
        const productId = event.target.value;
        this.loadProductConfig(productId);
    }

    loadProductConfig = (productId, products = this.state.products) => {
        const product = products.find(p => p.id === productId);
        
        let config = null;
        let rules = [];
        let maxInstallments = 1;

        if (product && product.installmentConfig) {
             config = product.installmentConfig;
             maxInstallments = config.maxInstallments;
             rules = config.rules || [];
        }

        // Initialize rules if empty or not enough
        if (rules.length === 0) {
            for (let i = 1; i <= maxInstallments; i++) {
                rules.push({ installment: i, interestRate: 0 });
            }
        }

        let productValue = 0;
        if (product && product.prices) {
            const brlPrice = product.prices.find(p => p.currency === 'BRL');
            if (brlPrice) {
                productValue = brlPrice.price;
            }
        }

        this.setState({ 
            selectedProductId: productId, 
            config: config,
            maxInstallments: maxInstallments,
            rules: rules,
            productValue: productValue
        }); 
    }

    handleMaxInstallmentsChange = (event) => {
        const newMax = parseInt(event.target.value, 10);
        let newRules = [...this.state.rules];

        if (newMax > newRules.length) {
            const lastRule = newRules[newRules.length - 1];
            const lastRate = lastRule ? lastRule.interestRate : 0;

            for (let i = newRules.length + 1; i <= newMax; i++) {
                newRules.push({ installment: i, interestRate: lastRate });
            }
        } else if (newMax < newRules.length) {
            newRules = newRules.slice(0, newMax);
        }

        this.setState({ maxInstallments: newMax, rules: newRules });
    }

    handleInterestRateChange = (index, value) => {
        const newRules = [...this.state.rules];
        const newRate = parseFloat(value);
        
        newRules[index].interestRate = newRate;

        this.setState({ rules: newRules });
    }

    handleSave = () => {
        const { selectedProductId, config, maxInstallments, rules } = this.state;
        this.setState({ saving: true });

        const payload = {
            data: {
                type: "product-installment-config",
                attributes: {
                    maxInstallments: maxInstallments,
                    rules: rules
                },
                relationships: {
                    product: {
                        data: {
                            type: "product",
                            id: selectedProductId
                        }
                    }
                }
            }
        };

        let promise;
        if (config) {
             const patchPayload = {
                data: {
                    type: "product-installment-config",
                    attributes: {
                        maxInstallments: maxInstallments,
                        rules: rules
                    }
                }
            };
            promise = this.props.fetchApi('patch', `/product-installment-configs/${config.id}`, patchPayload);
        } else {
            promise = this.props.fetchApi('post', '/product-installment-configs', payload);
        }

        promise.then(() => {
            this.props.showSnackbar('Configuração salva com sucesso!');
            this.setState({ saving: false });
            return this.fetchProducts(true);
        })
        .then((products) => {
            if (products) {
                this.loadProductConfig(selectedProductId, products);
            }
        })
        .catch(error => {
            console.error('Error saving config:', error);
            this.props.showSnackbar('Erro ao salvar configuração.');
            this.setState({ saving: false });
        });
    }

    render() {
        const { loading, products, selectedProductId, maxInstallments, rules, saving } = this.state;
        const selectedProduct = products.find(p => p.id === selectedProductId);

        if (loading) {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <CircularProgress />
                </div>
            );
        }

        return (
            <div style={{ padding: '2rem' }}>
                <Card style={{ padding: '2rem' }}>
                    <Typography variant="h5" gutterBottom>
                        Configurações de Parcelamento
                    </Typography>
                    
                    <div style={{ marginTop: '2rem' }}>
                        <InputLabel id="product-select-label">Produto Alvo</InputLabel>
                        <Select
                            labelId="product-select-label"
                            value={selectedProductId}
                            onChange={this.handleProductChange}
                            fullWidth
                            displayEmpty
                        >
                            <MenuItem value="" disabled>Selecione um produto</MenuItem>
                            {products.map(product => (
                                <MenuItem key={product.id} value={product.id}>
                                    {product.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>

                    {selectedProductId && (
                        <div style={{ marginTop: '2rem' }}>
                            <Grid container spacing={3} alignItems="center" style={{ marginBottom: '1rem' }}>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        label="Valor do Produto (R$)"
                                        value={this.state.productValue.toFixed(2)}
                                        disabled
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        label="Quantidade de Parcelas"
                                        type="number"
                                        value={maxInstallments}
                                        onChange={this.handleMaxInstallmentsChange}
                                        fullWidth
                                        InputProps={{ inputProps: { min: 1, max: 12 } }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                            </Grid>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Parcelas</TableCell>
                                            <TableCell>Tipo de Juros</TableCell>
                                            <TableCell>% Juros</TableCell>
                                            <TableCell>Valor de cada parcela</TableCell>
                                            <TableCell>Valor total</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rules.map((rule, index) => {
                                            const totalWithInterest = this.state.productValue * (1 + (rule.interestRate / 100));
                                            const installmentValue = totalWithInterest / rule.installment;

                                            return (
                                                <TableRow key={index}>
                                                    <TableCell>A partir de {rule.installment} {rule.installment === 1 ? 'Parcela' : 'Parcelas'}</TableCell>
                                                    <TableCell>
                                                        {rule.interestRate > 0 ? 'Com juros' : 'Sem juros'}
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            type="number"
                                                            value={rule.interestRate}
                                                            onChange={(e) => this.handleInterestRateChange(index, e.target.value)}
                                                            InputProps={{ inputProps: { min: 0, step: 0.1 } }}
                                                        />
                                                    </TableCell>
                                                    <TableCell>R$ {installmentValue.toFixed(2)}</TableCell>
                                                    <TableCell>R$ {totalWithInterest.toFixed(2)}</TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <div style={{ marginTop: '2rem', textAlign: 'right' }}>
                                <Button 
                                    variant="contained" 
                                    color="primary" 
                                    onClick={this.handleSave}
                                    disabled={saving}
                                >
                                    {saving ? 'Salvando...' : 'Salvar'}
                                </Button>
                            </div>
                        </div>
                    )}
                </Card>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/InstallmentConfig.js